var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.conditionallyActive(_vm.field, _vm.path))?_c('div',{key:_vm.fieldKey,staticClass:"fin-relative",class:!['inputGroup', 'pageColumns'].includes(_vm.field.type) ? 'fin-mb-3' : ''},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }